import { memo } from 'react'
import styled from 'astroturf/react'
const colorAccentPinkMedium = 'var(--colorAccentPinkMedium, var(--coreColorPink500))'
const colorSurfaceActionActive = 'var(--colorSurfaceActionActive, var(--coreColorBlue800))'
const colorIconInverseActive = 'var(--colorIconInverseActive, var(--coreColorBlue500))'

import { useI18n } from 'locales'
import { LocationIcon } from 'components/location/location_icon'

import AdditionalInfo from './additional_info'
import _Container from "label-Container.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/location/multiple/label.js?styleId=Container";
import _IconColumn from "label-IconColumn.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/location/multiple/label.js?styleId=IconColumn";
import _IconWrapper from "label-IconWrapper.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/location/multiple/label.js?styleId=IconWrapper";


const Container = /*#__PURE__*/styled('div', null, {
  displayName: "Container",
  styles: _Container
})

const IconColumn = /*#__PURE__*/styled('div', null, {
  displayName: "IconColumn",
  styles: _IconColumn
})

const IconWrapper = /*#__PURE__*/styled('div', null, {
  displayName: "IconWrapper",
  styles: _IconWrapper
})

// i18n-tasks-use t('booking.location.google_conference.label')
// i18n-tasks-use t('booking.location.gotomeeting_conference.label')
// i18n-tasks-use t('booking.location.zoom_conference.label')
// i18n-tasks-use t('booking.location.inbound_call.label')
// i18n-tasks-use t('booking.location.outbound_call.label')
// i18n-tasks-use t('booking.location.ask_invitee.label')
// i18n-tasks-use t('booking.location.microsoft_teams_conference.label')
// i18n-tasks-use t('booking.location.webex_conference.label')
const Label = ({ locationConfiguration, isSelected }) => {
  const { i18n } = useI18n()
  const locationLabel = locationConfiguration.location || i18n.t(`booking.location.${locationConfiguration.kind}.label`)
  const customLocation = locationConfiguration.kind === 'custom'

  return (
    <Container>
      {!customLocation && (
        <IconColumn>
          <IconWrapper kind={locationConfiguration.kind}>
            <LocationIcon
              kind={locationConfiguration.kind}
              data-testid={locationConfiguration.kind}
            />
          </IconWrapper>
        </IconColumn>
      )}
      <div>
        {locationLabel}
        <AdditionalInfo
          kind={locationConfiguration.kind}
          isSelected={isSelected}
        />
      </div>
    </Container>
  )
}

export default memo(Label)
